<template>

    <div class="box">
        <b-card class="d-flex flex-column justify-content-end align-items-center service-card" no-body v-for="(card, index) in cards" :key="index">
            <img class="background-image" :src="card.img" :alt="card.alt">
            <div class="content">
                <span><img src="@/assets/page/banner/rectangle.png" alt="Ícone de um pequeno retangulo azul" class="mr-2">{{ card.title }}</span>
                <p>{{ card.text }}</p>
            </div>
        </b-card>
    </div>

</template>

<script>

    export default {

        data(){
            return {
                cards: [
                    { title: "Cargas Agrícolas", text: 'Realizamos o transporte de commodites agrícolas, faciliando a conexão entre clientes, frotistas e motoristas, afim de auxiliar no escoamento da produção do agro nacional.', img: require('@/assets/page/services/image-agricolas.jpg'), alt: "Imagem de caminhão" },
                    { title: "Gerenciamento Logístico", text: 'Oferecemos soluções completas para a sua logística interna, incluindo cotação de fretes, documentação de transporte ( CT-e, MDF-e, CIOT), planejamento de rotas, report de posição, e etc.', img: require('@/assets/page/services/image-gerenciamento.jpg'), alt: "Imagem de Trabalhados Logístico" },
                    { title: "Cadeia de Suprimentos", text: 'Planejamos e coordenamos cada etapa da operação logística, organizando o fluxo de informações, o controle e acompanhamento, garantindo cumprimentos de prazos e reduzindo custos.', img: require('@/assets/page/services/image-suprimentos.jpg'), alt: "Imagem de Tablet" },
                    { title: "Segurança de Cargas", text: 'Priorizamos a segurança da sua carga em cada etapa do transporte, realizando o rastreamento contínuo e o gerenciamento proativo de riscos em tempo real.', img: require('@/assets/page/services/image-cargas.jpg'), alt: "Imagem de caminhão" },

                ],
            }
        }
    }

</script>

<style scoped lang="scss">

.box {
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
}

.service-card{
    position: relative;
    height: 100%;
    width: 25%;
    min-width: 350px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s ease;

    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &::after  {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--black);
        opacity: .6;
        z-index: 2;
    }

    .content {
        width: 100%;
        z-index: 3;
        color: var(--white);
        text-align: left;
        padding: 1rem ;
        position: relative;

        span {
            border-bottom: 1px solid var(--white);
            padding-bottom: .5rem;
            font-size: 1.5rem;
            display: block;
        }

        p {
            display: none;
            padding-top: .7rem;
        }
    }

    &:hover::after {
        background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.7), transparent);
        opacity: 1;
        transition: all 0.3s ease;
    }

    &:hover .content p {
        display: block;
    }
}

@media screen and (max-width: 1800px){
    .box{
        height: 100%;
        
    }

    .service-card{
        height: 500px;
        flex: 1;
        padding: 1rem !important;
    }
}

</style>

